<template>
    <svg class='svg svg--icon svg--info' width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M8 15.5C12.1421 15.5 15.5 12.1421 15.5 8C15.5 3.85786 12.1421 0.5 8 0.5C3.85786 0.5 0.5 3.85786 0.5 8C0.5 12.1421 3.85786 15.5 8 15.5Z' class='svg__stroke' stroke-linecap='round' stroke-linejoin='round' />
        <path d='M8 5C8.55228 5 9 4.55228 9 4C9 3.44772 8.55228 3 8 3C7.44772 3 7 3.44772 7 4C7 4.55228 7.44772 5 8 5Z' class='svg__fill' />
        <path d='M8 12.5V7' class='svg__stroke' stroke-linecap='round' stroke-linejoin='round' />
    </svg>
</template>